import { useCallback } from 'react';
import useStore from '../../../store';

/**
 * Return two Event Handler that notify the store about a user focusing a text input
 * This is used by other UI component to hide on mobile devices avoiding unintentionnal interaction during edition
 */
 export default function useTextInputFocus() {
  const setTextInputFocused = useStore(
    useCallback((state) => state.report.setTextInputFocused, [])
  );

  return {
    onFocus: useCallback(
      (handler?: (e: React.FocusEvent) => void) => (e?: React.FocusEvent) => {
        setTextInputFocused(true);
        if (handler) return handler(e);
      },
      []
    ),
    onBlur: useCallback(
      (handler?: (e: React.FocusEvent) => void) => (e?: React.FocusEvent) => {
        setTextInputFocused(false);
        if (handler) return handler(e);
      },
      []
    ),
  };
}